import { createSlice } from '@reduxjs/toolkit';

export interface GeneralInfoMobilityFormState {
  radius: number | string;
  dimension: boolean;
}

const initialState: GeneralInfoMobilityFormState = {
  radius: '',
  dimension: false,
};
export const generalInfoMobilitySlice = createSlice({
  name: 'generalInfoMobility',
  initialState,
  reducers: {
    setGeneralInfoMobilityStateDefault: () => {
      return { ...initialState };
    },
    submitGeneralInfoMobility: (state, action) => {
      state.radius = action.payload?.radius;
      state.dimension = action.payload?.dimension;
    },
  },
});

export const { setGeneralInfoMobilityStateDefault, submitGeneralInfoMobility } = generalInfoMobilitySlice.actions;

export default generalInfoMobilitySlice.reducer;
